import { createContext } from 'react'

export const ThemeContext = createContext({
  mode: 'light', // 'light' | 'dark' | 'system'
  resolvedMode: 'light', // 'light' | 'dark' - the actual mode being used
  setMode: () => {},
})
